import type { RootState } from '../reducers';

//
//
export const getSyncingCount = (state: RootState) => state.syncing.count;

//
//
export const getSyncingErrors = (state: RootState) => state.syncing.errors;
